import { faComments } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { useInjection } from 'inversify-react';
import { sortBy } from 'lodash';
import { observer } from 'mobx-react-lite';
import { ReactElement, useState } from 'react';
import { nameOf } from '../../../../../helpers/object.helpers';
import { SortingDirection } from '../../../../../models/sortingDirection.model';
import { IClarificationsStore } from '../Clarifications.store';
import { ClarificationsListModal } from '../components/ClarificationsListModal';
import { IClarification } from '../models/Clarifications.models';
import { IClarificationsBl } from '../services/Clarifications.bl';

export const ClarificationsArchiveListContainer = observer((): ReactElement => {
  const clarificationsStore = useInjection(IClarificationsStore.$);
  const clarificationsBl = useInjection(IClarificationsBl.$);

  const { t } = useTranslator();
  const [showClarificationsListModal, setShowClarificationsListModal] = useState(false);

  const handleToggleChange = (): void => {
    setShowClarificationsListModal((prevState) => !prevState);
  };

  const handleSortDirectionChange = (): void => {
    const currentSortingDirection = clarificationsStore.clarificationsListSortDirection;

    clarificationsBl.setClarificationsListSortDirection(currentSortingDirection === SortingDirection.ASC ? SortingDirection.DESC : SortingDirection.ASC);
  };

  const clarifications = clarificationsStore.archiveClarifications.filter((c) => c.answer);
  const sortedClarifications = sortBy(clarifications, nameOf<IClarification>('askedDate'), clarificationsStore.clarificationsListSortDirection);

  return (
    <>
      {clarifications.length > 0 && (
        <div className='image-clarifications-list'>
          <Button
            variant='outlined'
            onClick={handleToggleChange}
            startDecorator={<FontAwesomeIcon icon={faComments} />}
          >
            {t('clarifications.show_all_button')} ({clarifications.length})
          </Button>
          <ClarificationsListModal
            showModal={showClarificationsListModal}
            sortDirection={clarificationsStore.clarificationsListSortDirection}
            clarificationsList={sortedClarifications}
            onToggleChange={handleToggleChange}
            onSortDirectionChange={handleSortDirectionChange}
          />
        </div>
      )}
    </>
  );
});
